import { TextField } from '@mui/material'
import { type FC, useId } from 'react'
import { type Control, Controller } from 'react-hook-form'
import { LabeledField } from 'src/features/labelMaster/form/LabeledField'
import { type LabelMasterForm } from './labelMasterForm'

type Props = {
  control: Control<LabelMasterForm>
}

export const Code: FC<Props> = ({ control }) => {
  const id = useId()

  return (
    <LabeledField label="ラベルマスタ管理番号" htmlFor={id}>
      <Controller
        name="code"
        control={control}
        rules={{
          pattern: {
            value: /^[0-9]*$/,
            message: '数値で入力してください',
          },
          maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
          },
        }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            id={id}
            fullWidth
            inputMode="numeric"
            error={!!error}
            helperText={error?.message}
          />
        )}
      />
    </LabeledField>
  )
}
